import React, { useState } from 'react';
import { TherapistOption } from '../types/booking';
import { StarIcon, ClockIcon, AwardIcon } from 'lucide-react';
import { TherapistModal } from './TherapistModal';
interface TherapistCardProps {
  therapist: TherapistOption;
  onBook: (therapistName: string, time: string) => void;
}
export function TherapistCard({
  therapist,
  onBook
}: TherapistCardProps) {
  const [showModal, setShowModal] = useState(false);
  return <>
      <div className="bg-white rounded-xl border-2 border-gray-200 hover:border-purple-400 transition-all overflow-hidden" data-id="element-39">
        <div className="p-4" data-id="element-40">
          <div className="flex gap-4" data-id="element-41">
            <img src={therapist.imageUrl} alt={therapist.name} className="w-20 h-20 rounded-full object-cover" data-id="element-42" />
            <div className="flex-1" data-id="element-43">
              <div className="flex items-start justify-between" data-id="element-44">
                <div data-id="element-45">
                  <h3 className="font-semibold text-gray-900 text-lg" data-id="element-46">
                    {therapist.name}
                  </h3>
                  <div className="flex items-center gap-1 mt-1" data-id="element-47">
                    <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-48" />
                    <span className="text-sm font-medium text-gray-700" data-id="element-49">
                      {therapist.rating}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-50">
                      ({therapist.reviewCount} reviews)
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 bg-purple-100 px-3 py-1 rounded-full" data-id="element-51">
                  <ClockIcon className="w-4 h-4 text-purple-600" data-id="element-52" />
                  <span className="text-sm font-medium text-purple-600" data-id="element-53">
                    {therapist.time}
                  </span>
                </div>
              </div>
              <p className="text-sm text-gray-600 mt-2 line-clamp-2" data-id="element-54">
                {therapist.bio}
              </p>
              <div className="flex flex-wrap gap-2 mt-3" data-id="element-55">
                {therapist.specialties.slice(0, 2).map((specialty, index) => <span key={index} className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full flex items-center gap-1" data-id="element-56">
                    <AwardIcon className="w-3 h-3" data-id="element-57" />
                    {specialty}
                  </span>)}
              </div>
            </div>
          </div>
          <div className="flex gap-2 mt-4" data-id="element-58">
            <button onClick={() => setShowModal(true)} className="flex-1 px-4 py-2 border-2 border-purple-600 text-purple-600 rounded-full text-sm font-medium hover:bg-purple-50 transition-colors" data-id="element-59">
              View Profile
            </button>
            <button onClick={() => onBook(therapist.name, therapist.time)} className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-full text-sm font-medium hover:bg-purple-700 transition-colors" data-id="element-60">
              Book Now
            </button>
          </div>
        </div>
      </div>
      {showModal && <TherapistModal therapist={therapist} onClose={() => setShowModal(false)} onBook={() => {
      setShowModal(false);
      onBook(therapist.name, therapist.time);
    }} data-id="element-61" />}
    </>;
}